<template>
    <Modal :id="'Inscricao_Crud'" size="" :open="show" :FooterDefault="false" :ClassBG="true">
        <template v-slot:header>
            <h6 class="modal-title" style=" margin-left: -10px;">Gerar Localizador</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()"><i class="fas fa-times btn-close-style-v2 hover-effect"></i></button>
        </template>
        <template v-slot:body>
            <Form ref="Form_Inscricao" @submit="submitForm" style="overflow-y: auto; overflow-x: hidden; max-height: calc(100vh - 9rem);">
                <div class="row fundo-panel">
                    <div class="col-12">
                        <div class="">
                            <label class="form-label" style="font-size: 20px">Proposta Com Processo</label>
                        </div>
                        <div class="linha-cinza" style="margin-top: -5px"></div>
                        <select name="idTipoProposta" class="form-select shadow-v2 text-muted" v-model="InscricaoCrud.idProposta" @change="atualizaDadosResponsavel">
                            <option value="0" selected>Selecione</option>
                            <option :value="proposta.idProposta" selected v-for="proposta in propostas.filter(x => x.idInscricao == null)" :key="proposta.idProposta">
                                Nº Ano: {{ proposta.nrProposta }}/{{ proposta.nrAno }} |  Valor: R$ {{ proposta.vlProposta }} | Qtd Participantes: {{ proposta.qtdInscritos }} | Data Geração: {{ proposta.dtGeracao }}
                            </option>
                        </select>
                        <ErrorMessage name="idTipoProposta" class="form-error" v-show="showErrorMessage" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="">
                            <label class="form-label" style="font-size: 20px">Responsável da Inscrição</label>
                        </div>
                        <div class="linha-cinza" style="margin-top: -5px"></div>
                        <div class="row">
                            <div class="col">
                                <label for="nmNomeResponsavel" class="form-label">Nome</label>
                                <Field name="nmNomeResponsavel" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                       rules="required" v-model="InscricaoCrud.nmNomeResponsavel" />
                                <ErrorMessage name="nrProposta" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label for="dsEmailResponsavel" class="form-label">E-mail</label>
                                <Field name="dsEmailResponsavel" label="E-mail" type="text" class="form-control shadow-v2" v-model="InscricaoCrud.dsEmailResponsavel" />
                                <ErrorMessage name="dsEmailResponsavel" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Telefone</label>
                                <Field name="nrTelefoneResponsavel" label="nrTelefoneResponsavel" type="text" class="form-control shadow-v2"
                                       :class="{ filled: InscricaoCrud.nrTelefoneResponsavel }" rules="required"
                                       v-maska="'(##) ####-####'" v-model="InscricaoCrud.nrTelefoneResponsavel" />
                            </div>
                            <div class="col">
                                <label class="form-label">Celular</label>
                                <Field name="nrCelularResponsavel" label="nrCelularResponsavel" type="text" class="form-control shadow-v2"
                                       :class="{ filled: InscricaoCrud.nrCelularResponsavel }" rules="required"
                                       v-maska="'(##) #####-####'" v-model="InscricaoCrud.nrCelularResponsavel" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Departamento</label>
                                <vue-select :options="filtroDepartamento" v-model="departamento_responsavel_selected"
                                            :label-by="(e) => (e.nmDepartamento)"
                                            placeholder="Digite o nome do Departamento e selecione" searchable
                                            search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                            class="form-control shadow-v2"
                                            :class="{ filled: InscricaoCrud.idDepartamentoResponsavel > 0 }">
                                </vue-select>
                                <Field name="idDepartamentoResponsavel" label="Departamento" type="hidden" rules="min_value:1"
                                       v-model="InscricaoCrud.idDepartamentoResponsavel" />
                                <ErrorMessage name="idDepartamentoResponsavel" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label class="form-label">Função</label>
                                <vue-select :options="filtroFuncao" v-model="funcao_responsavel_selected"
                                            :label-by="(e) => (e.nmFuncao)" placeholder="Digite o nome da Função e selecione"
                                            searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                            :min="1" class="form-control shadow-v2"
                                            :class="{ filled: InscricaoCrud.idFuncaoResponsavel > 0 }">
                                </vue-select>
                                <Field name="idFuncaoResponsavel" label="Função" type="hidden" rules="min_value:1" v-model="InscricaoCrud.idFuncaoResponsavel" />
                                <ErrorMessage name="idFuncaoResponsavel" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col">
                            <div class="col-12 mt-3 mb-2">
                                <label class="form-control-checkbox mb-2">
                                    <input type="checkbox" @click="setMesmaPessoa()" /> O responsável pela inscrição é a mesma pessoa do financeiro.
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="">
                            <label class="form-label" style="font-size: 20px">Responsável Financeiro</label>
                        </div>
                        <div class="linha-cinza" style="margin-top: -5px"></div>
                        <div class="row">
                            <div class="col">
                                <label for="nmNomeFinanceiro" class="form-label">Nome</label>
                                <Field name="nmNomeFinanceiro" label="Nº Proposta" type="text" class="form-control shadow-v2" rules="required" v-model="InscricaoCrud.nmNomeFinanceiro" :readonly="flMesmaPessoa == true" />
                                <ErrorMessage name="nrProposta" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label for="dsEmailFinanceiro" class="form-label">E-mail</label>
                                <Field name="dsEmailFinanceiro" label="E-mail" type="text" class="form-control shadow-v2" v-model="InscricaoCrud.dsEmailFinanceiro" :readonly="flMesmaPessoa == true" />
                                <ErrorMessage name="dsEmailFinanceiro" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Telefone</label>
                                <Field name="nrTelefoneFinanceiro" label="nrTelefoneFinanceiro" type="text" class="form-control shadow-v2" :readonly="flMesmaPessoa == true"
                                       :class="{ filled: InscricaoCrud.nrTelefoneFinanceiro }" rules="required"
                                       v-maska="'(##) ####-####'" v-model="InscricaoCrud.nrTelefoneFinanceiro" />
                            </div>
                            <div class="col">
                                <label class="form-label">Celular</label>
                                <Field name="nrCelularFinanceiro" label="nrCelularFinanceiro" type="text" class="form-control shadow-v2" :readonly="flMesmaPessoa == true"
                                       :class="{ filled: InscricaoCrud.nrCelularFinanceiro }" rules="required"
                                       v-maska="'(##) #####-####'" v-model="InscricaoCrud.nrCelularFinanceiro" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Departamento</label>
                                <vue-select :options="filtroDepartamento" v-model="departamento_financeiro_selected"
                                            :label-by="(e) => (e.nmDepartamento)"
                                            placeholder="Digite o nome do Departamento e selecione" searchable
                                            search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                            class="form-control shadow-v2"
                                            :readonly="flMesmaPessoa == true"
                                            :class="{ filled: InscricaoCrud.idDepartamentoFinanceiro > 0 }">
                                </vue-select>
                                <Field name="idDepartamentoFinanceiro" label="Departamento" type="hidden" rules="min_value:1"
                                       v-model="InscricaoCrud.idDepartamentoFinanceiro" />
                                <ErrorMessage name="idDepartamentoFinanceiro" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label class="form-label">Função</label>
                                <vue-select :options="filtroFuncao" v-model="funcao_financeiro_selected"
                                            :label-by="(e) => (e.nmFuncao)" placeholder="Digite o nome da Função e selecione"
                                            searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                            :min="1" class="form-control shadow-v2"
                                            :disable="flMesmaPessoa == true"
                                            :class="{ filled: InscricaoCrud.idFuncaoFinanceiro > 0 }">
                                </vue-select>
                                <Field name="idFuncaoFinanceiro" label="Função" type="hidden" rules="min_value:1" v-model="InscricaoCrud.idFuncaoFinanceiro" />
                                <ErrorMessage name="idFuncaoFinanceiro" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </template>

        <!-- FOOTER -->
        <template v-slot:footer>
            <div class="modal-footer">
                <div class="row col-12">
                    <div class="col-1">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" style="        bottom: 6px;"
                            data-bs-dismiss="modal" @click="fecharModal()">Fechar</button>
                    </div>                 
                    <div class="col-11 d-flex justify-content-end">
                        <button type="submit" class="btn btn-red-v2" form="form" v-on:click="submitForm"                                style="        max-height: 10px;">
                            <i class="fas fa-save" style="        margin-right: 10px;"></i>Incluir
                        </button>
                    </div>
                </div>
            </div>
            
        </template>
    </Modal>
</template>

<script>

    import axios from 'axios';
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";
    import Modal from '@/components/App/Modal.vue'

    export default {
        name: 'Inscricao_Crud',
        components: {
            Modal,
            "vue-select": VueNextSelect,
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                flMesmaPessoa: false,
                InscricaoCrud: {
                    idProposta: 0,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    idFuncaoFinanceiro: 0,
                    idDepartamentoFinanceiro: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    idFuncaoResponsavel: 0,
                    idDepartamentoResponsavel: 0
                },
                filtroDepartamento: [],
                filtroFuncao: [],
                departamento_responsavel_selected: {},
                funcao_responsavel_selected: {},
                departamento_financeiro_selected: {},
                funcao_financeiro_selected: {},
                showErrorMessage: false,
                propostas: [],
            }
        },
        computed: {
        },
        methods: {
            setMesmaPessoa() {
                let $this = this;

                if ($this.flMesmaPessoa == false) {
                    this.flMesmaPessoa = true;
                    $this.InscricaoCrud.nmNomeFinanceiro = $this.InscricaoCrud.nmNomeResponsavel;
                    $this.InscricaoCrud.dsEmailFinanceiro = $this.InscricaoCrud.dsEmailResponsavel;
                    $this.InscricaoCrud.nrTelefoneFinanceiro = $this.InscricaoCrud.nrTelefoneResponsavel;
                    $this.InscricaoCrud.nrCelularFinanceiro = $this.InscricaoCrud.nrCelularResponsavel;
                    $this.departamento_financeiro_selected = $this.departamento_responsavel_selected;
                    $this.funcao_financeiro_selected = $this.funcao_responsavel_selected;
                    $this.InscricaoCrud.idFuncaoFinanceiro = $this.InscricaoCrud.idFuncaoResponsavel;
                    $this.InscricaoCrud.idDepartamentoFinanceiro = $this.InscricaoCrud.idDepartamentoResponsavel;
                } else {
                    this.flMesmaPessoa = false;
                    $this.InscricaoCrud.nmNomeFinanceiro = '';
                    $this.InscricaoCrud.dsEmailFinanceiro = '';
                    $this.InscricaoCrud.nrTelefoneFinanceiro = '';
                    $this.InscricaoCrud.nrCelularFinanceiro = '';
                    $this.departamento_financeiro_selected = {};
                    $this.funcao_financeiro_selected = {};
                    $this.InscricaoCrud.idFuncaoFinanceiro = 0;
                    $this.InscricaoCrud.idDepartamentoFinanceiro = 0;
                }
            },
            getDepartamento() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Departamento/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtroDepartamento = response.data.data.rows;
                });
            },
            getFuncao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Funcao/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtroFuncao = response.data.data.rows;
                });
            },
            GetPropostasProcessoInscricao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetPropostasProcessoInscricao?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.propostas = response.data.data;

                });
            },
            zerarInformacoes() {
                let $this = this;

                $this.InscricaoCrud = {

                };

                $this.showErrorMessage = false;
            },
            fecharModal() {
                this.zerarInformacoes();
            },
            submitForm(valida) {
                let $this = this;

                $this.InscricaoCrud.idOcorrencia = $this.idOcorrencia;

                if ($this.flMesmaPessoa == true) {
                    $this.InscricaoCrud.nmNomeFinanceiro = $this.InscricaoCrud.nmNomeResponsavel;
                    $this.InscricaoCrud.dsEmailFinanceiro = $this.InscricaoCrud.dsEmailResponsavel;
                    $this.InscricaoCrud.nrTelefoneFinanceiro = $this.InscricaoCrud.nrTelefoneResponsavel;
                    $this.InscricaoCrud.nrCelularFinanceiro = $this.InscricaoCrud.nrCelularResponsavel;
                    $this.InscricaoCrud.idFuncaoFinanceiro = $this.InscricaoCrud.idFuncaoResponsavel;
                    $this.InscricaoCrud.idDepartamentoFinanceiro = $this.InscricaoCrud.idDepartamentoResponsavel;
                }

                return new Promise((resolve, reject) => {
                    $this.$refs.Form_Inscricao.validate()
                        .then(isValid => {
                            if (isValid.valid) {
                                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GerarLocalizadorOcorrencia', $this.InscricaoCrud, { headers: $this.$api.getTokenEventos() })
                                    .then(function (response) {
                                        $this.$emit('GetOcorrenciaInscricoes');

                                        var myModalEl = document.getElementById('Inscricao_Crud');
                                        var ModalPedidoFat = window.bootstrap.Modal.getInstance(myModalEl);
                                        ModalPedidoFat.hide();
                                    })
                                    .catch(function (error) {
                                        var msg = 'Ocorreu um erro inesperado';
                                        if (error.response) {
                                            if (error.response.data.erros != '') {
                                                msg = error.response.data.errors[0];
                                            } else {
                                                msg = error.response.data.msg;
                                            }
                                        }

                                        $this.$toast.show('alert', msg, true);
                                    });
                                $this.showErrorMessage = false;
                            } else {
                                throw new Error('Por favor, preencha todos os campos obrigatórios');
                            }
                        })
                        .catch(error => {
                            var msg = 'Por favor, preencha todos os campos obrigatórios';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }
                            $this.showErrorMessage = true;
                            $this.$toast.show('alert', msg, true);
                        });
                });
            },
            atualizaDadosResponsavel() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetByEmail?dsEmail=' + this.propostas.filter(x => x.idProposta == this.InscricaoCrud.idProposta)[0].dsEmail + '&idInstituicao=' + ($this.idInstituicao > 0 ? $this.idInstituicao : 0) + '&nao_valida=true', {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.InscricaoCrud.nmNomeResponsavel = response.data.data.nmPessoa;
                    $this.InscricaoCrud.dsEmailResponsavel = response.data.data.dsEmail;
                    $this.InscricaoCrud.nrTelefoneResponsavel = response.data.data.nrTelefone;
                    $this.InscricaoCrud.nrCelularResponsavel = response.data.data.nrCelular;
                    $this.InscricaoCrud.idDepartamentoResponsavel = response.data.data.idDepartamento;
                    $this.InscricaoCrud.idFuncaoResponsavel = response.data.data.idFuncao;

                    setTimeout(() => {

                        if ($this.InscricaoCrud.idDepartamentoResponsavel != null && $this.InscricaoCrud.idDepartamentoResponsavel > 0) {
                            $this.departamento_responsavel_selected = $this.filtroDepartamento.find(o => {
                                return o.idDepartamento === $this.InscricaoCrud.idDepartamentoResponsavel;
                            });
                        }

                        if ($this.InscricaoCrud.idFuncaoResponsavel != null && $this.InscricaoCrud.idFuncaoResponsavel > 0) {
                            $this.funcao_responsavel_selected = $this.filtroFuncao.find(o => {
                                return o.idFuncao === $this.InscricaoCrud.idFuncaoResponsavel;
                            });
                        }

                    }, 250);
                })
            }
        },
        mounted() {
            this.getDepartamento();
            this.getFuncao();
            this.GetPropostasProcessoInscricao();
        },
        updated() {
        },
        watch: {
            show(new_value, old_value) {
                this.InscricaoCrud = {
                    idProposta: 0,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    idFuncaoFinanceiro: 0,
                    idDepartamentoFinanceiro: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    idFuncaoResponsavel: 0,
                    idDepartamentoResponsavel: 0
                };
                this.GetPropostasProcessoInscricao();
            },
            idOcorrencia(new_value, old_value) { },
            'InscricaoCrud.nmNomeResponsavel': function (n) {
                if (this.flMesmaPessoa == true) {
                    this.InscricaoCrud.nmNomeFinanceiro = n;
                }
            },
            'InscricaoCrud.dsEmailResponsavel': function (n) {
                if (this.flMesmaPessoa == true) {
                    this.InscricaoCrud.dsEmailFinanceiro = n;
                }
            },
            'InscricaoCrud.nrTelefoneResponsavel': function (n) {
                if (this.flMesmaPessoa == true) {
                    this.InscricaoCrud.nrTelefoneFinanceiro = n;
                }
            },
            'InscricaoCrud.nrCelularResponsavel': function (n) {
                if (this.flMesmaPessoa == true) {
                    this.InscricaoCrud.nrCelularFinanceiro = n;
                }
            },
            'InscricaoCrud.idProposta': function (n) {
                if (n > 0) {
                    /*console.log('idProposta ', n);*/
                }
            },

            departamento_responsavel_selected(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.idDepartamentoResponsavel = newValue.idDepartamento;
                    if (this.flMesmaPessoa) { this.departamento_financeiro_selected = newValue; this.InscricaoCrud.idDepartamentoFinanceiro = newValue.idDepartamento; }
                }
            },

            funcao_responsavel_selected(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.idFuncaoResponsavel = newValue.idFuncao;
                    if (this.flMesmaPessoa) { this.funcao_financeiro_selected = newValue; this.InscricaoCrud.idFuncaoFinanceiro = newValue.idFuncao; }
                }
            },

            departamento_financeiro_selected(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.idDepartamentoFinanceiro = newValue.idDepartamento;
                }
            },
            funcao_financeiro_selected(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.idFuncaoFinanceiro = newValue.idFuncao;
                }
            },

        },
    }

</script>

<style scoped lang="scss">
  
</style>